import { observer } from 'mobx-react-lite'
import { useEffect, useState } from 'react'
import { Modal, useModals } from 'almanac-ui/Modal'
import { RevisionType } from '../Types'
import Styles from '../BlazeCommandLine.module.scss'
import TranslateModalStyles from './TranslateModal.module.scss'
import { RevisionSelection } from '../api/createRevisionRequest'
import { ReviseButton } from 'components/BlazeCommandLine/components/ReviseButton'
import { AlmanacEditorState } from 'stores/EditorState'
import { Selection } from 'hooks/queries/layers/revisions/useCreateRevision'
import { DEFAULT_LANGUAGE, LanguageInput } from 'components/Wizards/Wizard/Form/LanguageInputField/LanguageInput'
import { useLastUsedLanguage } from 'hooks/queries/useLastUsedLanguage'
import { Spinner } from 'common/Spinner/Spinner'
import { Heading } from 'almanac-ui/Heading/Heading'

interface Props {
  articleId: string
  layerId: string
  selection?: RevisionSelection
  almanacEditorState?: AlmanacEditorState
  previousRevisionId?: string
}

export const TranslateModal = observer(
  ({ articleId, layerId, selection, almanacEditorState, previousRevisionId }: Props) => {
    const { closeAllModals, closeModal } = useModals()
    const defaultLanguageQuery = useLastUsedLanguage()
    const defaultLanguage = defaultLanguageQuery?.data?.language
    const [selectedLanguage, setSelectedLanguage] = useState<string>(DEFAULT_LANGUAGE)

    useEffect(() => {
      if (!!defaultLanguage) setSelectedLanguage(defaultLanguage)
    }, [defaultLanguage]) // eslint-disable-line react-hooks/exhaustive-deps

    return (
      <Modal.Root aria-labelledby="translate-header" size="sm">
        <Modal.Header title="Translate" id="translate-header" />

        <Modal.Content>
          <div className={Styles.section}>
            <Heading level={4}>Select Language</Heading>
            {defaultLanguageQuery.isLoading || !defaultLanguageQuery?.data?.language ? (
              <div className={TranslateModalStyles.spinnerContainer}>
                <Spinner />
              </div>
            ) : (
              <LanguageInput onLanguageChange={setSelectedLanguage} languageValue={selectedLanguage} />
            )}
          </div>
        </Modal.Content>

        <Modal.Footer>
          <Modal.FooterContent slot="left">
            <Modal.FooterButton size="lg" variant="tertiary" onPress={closeModal}>
              Back
            </Modal.FooterButton>
          </Modal.FooterContent>
          <Modal.FooterContent slot="right">
            <div className={Styles.buttonGroup} id="doc-generation-modal-generate">
              {almanacEditorState && selection && (
                <ReviseButton
                  selection={selection as Selection}
                  almanacEditorState={almanacEditorState}
                  articleId={articleId}
                  layerId={layerId}
                  prompt={{ revision_type: RevisionType.TRANSLATE, language: selectedLanguage || 'English' }}
                  onRevise={closeAllModals}
                  previousRevisionId={previousRevisionId}
                  label="Translate"
                />
              )}
            </div>
          </Modal.FooterContent>
        </Modal.Footer>
      </Modal.Root>
    )
  },
)
